import { Component } from '@angular/core';

@Component({
	template: require('./p0.component.html')
})
export class SmP0Component { }


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/components/p0.component.ts